import { resolveLocalityId } from '@domain-group/fe-allhomes-search-api';
export var getSurroundingSuburbs = (localities, localityMap) => localities.map(locality => resolveLocalityId(locality, localityMap)).filter(locality => locality != null).map(locality => {
  switch (locality.type) {
    case 'STREET':
    case 'DIVISION':
    case 'DISTRICT':
      return locality.parent || locality;
    default:
      return locality;
  }
});